import { __decorate } from "tslib";
import { attr, customElement, FASTElement, html } from '@microsoft/fast-element';
import { SVG_CHEVRON_DOWN } from '@getgo/chameleon-icons';
import { ChameleonElementMixin } from '../common/ChameleonElement';
import { assertSlotNonNull } from '../common/asserts';
import { getHostChildsFromEvent } from '../common/utils/DomUtil';
import styles from './SplitButton.styles.scss';
const template = html `<div @click=${(x, { event }) => x.clickHandler(event)}>
  <chameleon-button class="action" variant="${(x) => x.variant}" size="${(x) => x.size}"
  disabled=${(x) => x.disabled}
    ><span slot="start">
      <slot name="start"></slot>
    </span>
    <slot></slot
  ></chameleon-button>
  <chameleon-popover position="${(x) => x.position}" menu>
    <chameleon-button slot="trigger" variant="${(x) => x.variant}" size="${(x) => x.size}"
    disabled=${(x) => x.disabled}
      ><chameleon-svg>${SVG_CHEVRON_DOWN}<chameleon-svg></chameleon-button
    >
    <div slot="content">
      <slot name="actions"></slot>
    </div>
  </chameleon-popover>
</div>`;
export const splitButtonDefinition = {
    name: 'chameleon-split-button',
    template,
    styles,
};
let SplitButtonComponent = class SplitButtonComponent extends ChameleonElementMixin(FASTElement) {
    constructor() {
        super(...arguments);
        this.size = 'medium';
        this.variant = 'primary';
        this.position = 'bottom-end';
        this.disabled = false;
        this.getActionButton = () => { var _a; return (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.action'); };
        this.getPopover = () => { var _a; return (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('chameleon-popover'); };
        this.popoverChangeHandler = (e) => this.$emit('popoverchange', e.detail, { bubbles: false });
    }
    connectedCallback() {
        var _a;
        super.connectedCallback();
        this.assertForActionsSlot();
        (_a = this.getPopover()) === null || _a === void 0 ? void 0 : _a.addEventListener('popoverchange', this.popoverChangeHandler);
    }
    disconnectedCallback() {
        var _a;
        super.disconnectedCallback();
        (_a = this.getPopover()) === null || _a === void 0 ? void 0 : _a.removeEventListener('popoverchange', this.popoverChangeHandler);
    }
    clickHandler(e) {
        const actionButton = this.getActionButton();
        if (actionButton) {
            const childs = getHostChildsFromEvent(e, actionButton);
            if (!childs.length) {
                e.stopImmediatePropagation();
            }
        }
    }
    assertForActionsSlot() {
        const actionsElement = this.querySelector('[slot="actions"]');
        assertSlotNonNull(actionsElement, 'SplitButtonComponent', 'actions');
    }
};
__decorate([
    attr
], SplitButtonComponent.prototype, "size", void 0);
__decorate([
    attr
], SplitButtonComponent.prototype, "variant", void 0);
__decorate([
    attr
], SplitButtonComponent.prototype, "position", void 0);
__decorate([
    attr({ mode: 'boolean' })
], SplitButtonComponent.prototype, "disabled", void 0);
SplitButtonComponent = __decorate([
    customElement(splitButtonDefinition)
], SplitButtonComponent);
export { SplitButtonComponent };
